import React, { useState } from "react";
import { Link } from 'react-router-dom';
import "./contact.css";

export default function Contact() {
  const [isLoading, setIsLoading] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null); // 'success' or 'error'
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    type: '',
    description: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    // Hide success/error messages when user starts typing again
    if (submitStatus) {
      setSubmitStatus(null);
    }
  };

  const isFormValid = () => {
    return formData.fullName.trim() !== '' &&
           formData.email.trim() !== '' &&
           /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email) &&
           formData.type !== '' &&
           formData.description.trim() !== '';
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setSubmitStatus(null);
    
    const submitData = {
      fullName: formData.fullName,
      email: formData.email,
      type: formData.type,
      description: formData.description,
    };

    try {
      const response = await fetch('https://updatedwebsitecontact-3juuoo4lua-uc.a.run.app', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(submitData),
      });

      const data = await response.json();

      if (response.ok && data.success) {
        setSubmitStatus('success');
        setFormData({
          fullName: '',
          email: '',
          type: '',
          description: ''
        });
        // Scroll to top of page
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } else {
        setSubmitStatus('error');
        console.error('Form submission error:', data);
      }
    } catch (error) {
      setSubmitStatus('error');
      console.error('Network error:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="contact-page">
      <div className="contact-container">
        <h1 className="contact-title">Contact Us</h1>
        <p className="contact-subtitle">
          We want to hear from you. Please reach out with any questions or feedback!
        </p>
        
        {submitStatus === 'success' && (
          <div className="success-message">
            ✓ Thank you! Your message has been sent successfully.
          </div>
        )}
        
        {submitStatus === 'error' && (
          <div className="error-message">
            ✗ Sorry, there was an error sending your message. Please try again.
          </div>
        )}
        
        <form className="contact-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="fullName">Full Name</label>
            <input 
              type="text" 
              id="fullName" 
              name="fullName" 
              value={formData.fullName}
              onChange={handleInputChange}
              placeholder="Enter your full name"
              required 
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input 
              type="email" 
              id="email" 
              name="email" 
              value={formData.email}
              onChange={handleInputChange}
              placeholder="Enter your email"
              required 
            />
          </div>

          <div className="form-group">
            <label htmlFor="type">Inquiry Type</label>
            <select 
              id="type" 
              name="type" 
              value={formData.type}
              onChange={handleInputChange}
              required
            >
              <option value="">Select an option...</option>
              <option value="general">General Inquiry</option>
              <option value="catering">Catering</option>
              <option value="feedback">Feedback</option>
              <option value="complaint">Complaint</option>
              <option value="other">Other</option>
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="description">Description</label>
            <textarea 
              id="description" 
              name="description" 
              rows="6" 
              value={formData.description}
              onChange={handleInputChange}
              placeholder="Tell us more..."
              required
            ></textarea>
          </div>

          <button 
            type="submit" 
            className="submit-btn"
            disabled={!isFormValid() || isLoading}
          >
            Submit
          </button>
        </form>

        <div className="contact-privacy-link-wrap">
          <Link to="/privacy" className="contact-privacy-link">
            Privacy Policy
          </Link>
        </div>
      </div>

      {isLoading && (
        <div className="loading-overlay">
          <div className="loading-spinner"></div>
        </div>
      )}
    </div>
  );
}
